import { Box, Button, Typography } from '@mui/material';
import { Link, useRouterState } from '@tanstack/react-router';

import { useAuthContext } from '@/context/AuthContext';
import { PENDING_PREFIXES } from './routes';

export function PlaceholderPage() {
  const { isAuthenticated } = useAuthContext();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const pending = PENDING_PREFIXES.some((p) => pathname.startsWith(p));

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {pending ? 'This page is coming soon.' : 'Page not found.'}
      </Typography>
      <Typography sx={{ mb: 3 }}>
        {pending
          ? 'This part of inside.gallery is not ready yet. Please come back later.'
          : 'Check the address and try again.'}
      </Typography>
      <Button component={Link} to={isAuthenticated ? '/dashboard' : '/'}>
        {isAuthenticated ? 'Go to my dashboard' : 'Go to the home page'}
      </Button>
    </Box>
  );
}
